var map = {
	"./filters/close.svg": "6Ulw",
	"./logos/canon.svg": "KRq7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aWah";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images \.svg$
// module id = aWah
// module chunks = 0